import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { PipelineActivityService } from '../../../pipeline/services/pipeline-activity.service';
import { NoDataActionType, NoDataSourceType, NoDataTypes } from '../../interfaces/no-data';

@Component({
    selector: 'app-loan-card-details',
    templateUrl: './loan-card-details.component.html',
    styleUrls: ['./loan-card-details.component.css'],
})
export class LoanCardDetailsComponent implements OnInit, OnChanges {
    loading: boolean = false;
    data: any;
    noDataSelection: NoDataTypes;
    readonly ESTIMATED_CLOSE_TOOLTIP = 'Projected loan close date mapped from your LOS.';
    readonly PREDICTED_CLOSE_TOOLTIP =
        "Earliest date the loan might close. Calculated by nCino IQ (nIQ) with a combination of artificial intelligence and analytics that uses your company's historical loan data.";

    @Input() loanNumber: string;
    @Output() dataLoaded: EventEmitter<any> = new EventEmitter<any>();
    constructor(private _activityService: PipelineActivityService) {}

    ngOnInit(): void {
        this.noDataSelection = {
            action: NoDataActionType.emptySelect,
            searchTerm: 'Milestones',
            componentTitle: 'loan details',
            inputSource: NoDataSourceType.smallDataCard,
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        this.load();
    }

    load() {
        this.loading = true;

        try {
            this._activityService.getLoanDetails(this.loanNumber).subscribe(
                (res) => {
                    this.data = res;

                    if (this.data && this.data.lastLOSUpdate) {
                        this.dataLoaded.emit({ data: this.data.lastLOSUpdate });
                    }

                    this.loading = false;
                },
                (error) => {
                    throw error;
                }
            );
        } catch (e) {
            this.loading = false;
            this.data = null;
        }
    }

    isActiveStatus() {
        if (this.data && this.data.daystoExpiration && this.data.daystoExpiration > 0) {
            return true;
        } else {
            return false;
        }
    }
}
